export default __webpack_public_path__ + "media/zurb/img/b2b_ecommerce/lin_mobile-68f1d6409b12896da383289dc87364eb.png";